import { useLanguage } from "../../components/LanguageProvider/LanguageProvider";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import Applications from "../../components/User/Applications";
import { applicationStatusMap } from "../../config/applicationStatusConfig";

const PaymentDone = () => {
  const { language, setLanguage } = useLanguage();
  return (
    <DashboardLayout
      pageTitle={language ? "आवेदन" : "Application"}
      mainClass="p-6"
    >
      <Applications
        title={language ? "भुगतान पूर्ण आवेदन" : "Payment Done Applications"}
        status={[applicationStatusMap?.paymentDone]}
      />
    </DashboardLayout>
  );
};

export default PaymentDone;
